var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/Register/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import axios from "axios";
import Cookie from "js-cookie";
import merge from "lodash.merge";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useReducer, useState } from "react";
import { AccountTypes } from "../Account";
import Spinner from "../Spinner";
import { login, authorizeToken } from "./helpers/auth";
import { formatErrorMessage, ErrorMessages } from "./helpers/errors";
import isValid from "./helpers/validation";
import RegistrationForm from "./RegistrationForm";
import { RegisterSection, RegisterContainer, RegisterHeader, RegisterSubHeader } from "./styles";
var RegisterStateActionTypes = {
  UPDATE_INPUTS: "UPDATE_INPUTS",
  VALIDATE_OUTPUT: "VALIDATE_OUTPUT",
  REGISTRATION_ERRORS: "REGISTRATION_ERRORS",
  HANDLE_FIELD_CHANGE: "HANDLE_FIELD_CHANGE",
  HANDLE_FOCUS: "HANDLE_FOCUS",
  CLEAR_ERROR: "CLEAR_ERROR",
  UPDATE_AUTHENTICATED: "UPDATE_AUTHENTICATED"
};
var noop = function noop() {
  return null;
};
var DefaultCopyConfig = {
  birthdayLabel: "Date of Birth",
  confirmPasswordPlaceholder: "Confirm Password",
  dayPlaceholder: "DD",
  emailPlaceholder: "Email",
  header: "",
  loginLabel: "Already have an account?",
  loginLink: "Log In",
  monthPlaceholder: "MM",
  optInLabel: 'I would like to receive commercial e-mails from <a href="/" target="_blank">MLB.com</a> and their partners.',
  passwordPlaceholder: "Create Password",
  policyLabel: 'I understand and agree to be bound by the MLB.com <a href="/official-information/terms-of-use" target="_blank">Terms of Use</a> and <a href="/official-information/privacy-policy" target="_blank">Privacy Policy</a>.',
  submitButton: "Register",
  successHeader: "Registration Success",
  successSubHeader: "",
  subHeader: "",
  widgetHeader: "",
  yearPlaceholder: "YYYY"
};
var DefaultTracking = {
  registerSuccessProps: {},
  registerFailureProps: {},
  registerSubmitProps: {}
};
var defaultPopoverOffset = [0, 10];
var Register = function Register(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? "#fff" : _ref$backgroundColor,
    _ref$birthday = _ref.birthday,
    birthday = _ref$birthday === void 0 ? {
      day: null,
      month: null,
      year: null
    } : _ref$birthday,
    _ref$birthdayDisabled = _ref.birthdayDisabled,
    birthdayDisabled = _ref$birthdayDisabled === void 0 ? false : _ref$birthdayDisabled,
    _ref$classPrefix = _ref.classPrefix,
    classPrefix = _ref$classPrefix === void 0 ? "register" : _ref$classPrefix,
    containerProps = _ref.containerProps,
    _ref$containerWidth = _ref.containerWidth,
    containerWidth = _ref$containerWidth === void 0 ? "600px" : _ref$containerWidth,
    copyConfig = _ref.copyConfig,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? "" : _ref$email,
    _ref$emailDisabled = _ref.emailDisabled,
    emailDisabled = _ref$emailDisabled === void 0 ? false : _ref$emailDisabled,
    _ref$isEU = _ref.isEU,
    isEU = _ref$isEU === void 0 ? false : _ref$isEU,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? "en-US" : _ref$locale,
    _ref$onClickLoginLink = _ref.onClickLoginLink,
    onClickLoginLink = _ref$onClickLoginLink === void 0 ? noop : _ref$onClickLoginLink,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? noop : _ref$onError,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? noop : _ref$onSuccess,
    _ref$popoverPosition = _ref.popoverPosition,
    popoverPosition = _ref$popoverPosition === void 0 ? "top" : _ref$popoverPosition,
    _ref$popoverOffset = _ref.popoverOffset,
    popoverOffset = _ref$popoverOffset === void 0 ? defaultPopoverOffset : _ref$popoverOffset,
    _ref$setAccountType = _ref.setAccountType,
    setAccountType = _ref$setAccountType === void 0 ? noop : _ref$setAccountType,
    _ref$showOptinCheckbo = _ref.showOptinCheckbox,
    showOptinCheckbox = _ref$showOptinCheckbo === void 0 ? true : _ref$showOptinCheckbo,
    _ref$showPolicy = _ref.showPolicy,
    showPolicy = _ref$showPolicy === void 0 ? true : _ref$showPolicy,
    _ref$stacked = _ref.stacked,
    stacked = _ref$stacked === void 0 ? false : _ref$stacked,
    tracking = _ref.tracking;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    oktaClient = _useState2[0],
    setOktaClient = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var day = birthday.day,
    month = birthday.month,
    year = birthday.year;
  var combinedCopyConfig = useMemo(function () {
    return merge(DefaultCopyConfig, copyConfig);
  }, [copyConfig]);
  var header = combinedCopyConfig.header,
    subHeader = combinedCopyConfig.subHeader,
    successHeader = combinedCopyConfig.successHeader,
    successSubHeader = combinedCopyConfig.successSubHeader;
  var _useMemo = useMemo(function () {
      return merge(DefaultTracking, tracking);
    }, [tracking]),
    registerSuccessProps = _useMemo.registerSuccessProps,
    registerFailureProps = _useMemo.registerFailureProps,
    registerSubmitProps = _useMemo.registerSubmitProps;

  // need to pad values with 0 since form gives us single digit
  var zeroPad = function zeroPad(num, places) {
    return String(num).padStart(places, "0");
  };
  var days = "";
  var months = "";
  var years = "";
  if (day && month && year) {
    days = zeroPad(day, 2);
    months = zeroPad(month, 2);
    years = zeroPad(year, 2);
  }
  var initialRegisterState = {
    authenticated: false,
    inputs: {
      email: email,
      emailValid: null,
      password: "",
      passwordValid: null,
      confirmPassword: "",
      confirmPasswordValid: null,
      months: months,
      monthsValid: null,
      days: days,
      daysValid: null,
      years: years,
      yearsValid: null,
      optInChecked: false,
      euTosPriv: false
    },
    inputPrompt: false,
    error: null,
    errorMessage: null,
    showError: false
  };
  useEffect(function () {
    setOktaClient(window.mlbOkta.getAuthClient());
  }, []);
  useEffect(function () {
    if (oktaClient) {
      checkAuthentication();
    }
  }, [oktaClient]);
  var checkAuthentication = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var authenticated;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validateOktaTokens();
            case 2:
              authenticated = _context.sent;
              if (!authenticated) {
                oktaClient.tokenManager.remove("accessToken");
                oktaClient.tokenManager.remove("idToken");
              }
              if (authenticated !== registerState.authenticated) {
                setAuthenticated(authenticated, null);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function checkAuthentication() {
      return _ref2.apply(this, arguments);
    };
  }();
  var validateOktaTokens = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var claims;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object" || !window.mlbOkta)) {
                _context2.next = 3;
                break;
              }
              console.warn("Missing Okta Validate library");
              return _context2.abrupt("return", false);
            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return window.mlbOkta.isLoggedIn();
            case 6:
              claims = _context2.sent;
              return _context2.abrupt("return", Boolean(claims));
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              return _context2.abrupt("return", false);
            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 10]]);
    }));
    return function validateOktaTokens() {
      return _ref3.apply(this, arguments);
    };
  }();
  var reducer = function reducer(state, action) {
    var _objectSpread2;
    var type = action.type,
      payload = action.payload;
    switch (type) {
      case RegisterStateActionTypes.UPDATE_INPUTS:
        return _objectSpread(_objectSpread({}, state), {}, {
          inputs: _objectSpread(_objectSpread({}, state.inputs), {}, {
            daysValid: payload.daysValid,
            monthsValid: payload.monthsValid,
            yearsValid: payload.yearsValid
          })
        });
      case RegisterStateActionTypes.VALIDATE_OUTPUT:
        return _objectSpread(_objectSpread({}, state), {}, {
          inputs: _objectSpread(_objectSpread({}, state.inputs), payload)
        });
      case RegisterStateActionTypes.REGISTRATION_ERRORS:
        return _objectSpread(_objectSpread({}, state), {}, {
          inputs: _objectSpread(_objectSpread({}, state.inputs), {}, {
            emailValid: payload.emailValid,
            passwordValid: payload.passwordValid,
            confirmPasswordValid: payload.confirmPasswordValid,
            monthsValid: payload.monthsValid,
            daysValid: payload.daysValid,
            yearsValid: payload.yearsValid
          })
        });
      case RegisterStateActionTypes.HANDLE_FIELD_CHANGE:
        return _objectSpread(_objectSpread({}, state), {}, {
          inputs: _objectSpread(_objectSpread({}, state.inputs), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, payload.fieldType, payload.inputValue), _defineProperty(_objectSpread2, "emailValid", payload.emailValid), _defineProperty(_objectSpread2, "passwordValid", payload.passwordValid), _defineProperty(_objectSpread2, "confirmPasswordValid", payload.confirmPasswordValid), _defineProperty(_objectSpread2, "monthsValid", payload.monthsValid), _defineProperty(_objectSpread2, "daysValid", payload.daysValid), _defineProperty(_objectSpread2, "yearsValid", payload.yearsValid), _objectSpread2))
        });
      case RegisterStateActionTypes.HANDLE_FOCUS:
        return _objectSpread(_objectSpread({}, state), {}, {
          inputPrompt: payload.inputPrompt
        });
      case RegisterStateActionTypes.CLEAR_ERROR:
        return _objectSpread(_objectSpread({}, state), {}, {
          showError: false
        });
      case RegisterStateActionTypes.UPDATE_AUTHENTICATED:
        return _objectSpread(_objectSpread({}, state), {}, {
          authenticated: payload.authenticated,
          error: payload.error,
          errorMessage: payload.errorMessage,
          isCoppaIneligible: payload.isCoppaIneligible,
          showError: payload.showError
        });
      case RegisterStateActionTypes.CHECK_INELIGIBILITY:
        return _objectSpread(_objectSpread({}, state), {}, {
          errorMessage: payload.errorMessage,
          isCoppaIneligible: payload.isCoppaIneligible,
          showError: payload.showError
        });
      default:
        return state;
    }
  };
  var _useReducer = useReducer(reducer, initialRegisterState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    registerState = _useReducer2[0],
    dispatchRegisterState = _useReducer2[1];
  var clearError = function clearError() {
    dispatchRegisterState({
      type: RegisterStateActionTypes.CLEAR_ERROR,
      payload: {
        showError: false
      }
    });
  };
  var setAuthenticated = function setAuthenticated() {
    var auth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var error = arguments.length > 1 ? arguments[1] : undefined;
    var errorMessage = error ? formatErrorMessage(error, locale) : "";
    var isCoppaIneligible = errorMessage === ErrorMessages.COPPA;
    if (isCoppaIneligible) {
      Cookie.set("registration_coppa_ineligible", "true", {
        expires: 365
      });
    }
    dispatchRegisterState({
      type: RegisterStateActionTypes.UPDATE_AUTHENTICATED,
      payload: {
        authenticated: auth,
        error: error,
        errorMessage: errorMessage,
        showError: Boolean(error)
      }
    });
  };
  var setValidationErrorBehavior = function setValidationErrorBehavior(validationOutput) {
    var emailValid = validationOutput.emailValid,
      passwordValid = validationOutput.passwordValid,
      confirmPasswordValid = validationOutput.confirmPasswordValid,
      monthsValid = validationOutput.monthsValid,
      daysValid = validationOutput.daysValid,
      yearsValid = validationOutput.yearsValid,
      dobValid = validationOutput.dobValid,
      dobReason = validationOutput.dobReason;
    var dobInputsValid = monthsValid && daysValid && yearsValid;
    if (!emailValid) {
      setAuthenticated(false, {
        errorName: "EMAIL"
      });
      return;
    }
    if (!passwordValid) {
      setAuthenticated(false, {
        errorName: "PASSWORD"
      });
      return;
    }
    if (!confirmPasswordValid) {
      setAuthenticated(false, {
        errorName: "CONFIRM_PASSWORD"
      });
      return;
    }
    if (!dobInputsValid) {
      setAuthenticated(false, {
        errorName: "DOB"
      });
      return;
    }
    if (!dobValid && dobReason === "func") {
      setAuthenticated(false, {
        errorName: "COPPA"
      });
      dispatchRegisterState({
        type: RegisterStateActionTypes.UPDATE_INPUTS,
        payload: {
          daysValid: false,
          monthsValid: false,
          yearsValid: false
        }
      });
    }
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var inputs, months, days, years, optInChecked, euTosPriv, registrationValues, validationOutput, areFieldsValid, config, registerUrl, _email, _years, _months, _days, postData, registerResponse, registerError, logins, tokenAuthorized, _window$mlbOkta$decod, sub;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (window.trackAsync) {
                window.trackAsync(registerSubmitProps);
              }
              inputs = registerState.inputs;
              months = inputs.months, days = inputs.days, years = inputs.years, optInChecked = inputs.optInChecked, euTosPriv = inputs.euTosPriv;
              registrationValues = _objectSpread(_objectSpread({}, inputs), {}, {
                dob: "".concat(months, "/").concat(days, "/").concat(years)
              });
              validationOutput = isValid(registrationValues);
              dispatchRegisterState({
                type: RegisterStateActionTypes.VALIDATE_OUTPUT,
                payload: validationOutput
              });
              areFieldsValid = Object.keys(validationOutput).every(function (k) {
                var isReason = k.indexOf("Reason") > -1;
                if (isReason) {
                  return true;
                }
                return validationOutput[k];
              });
              if (areFieldsValid) {
                _context3.next = 10;
                break;
              }
              setValidationErrorBehavior(validationOutput);
              return _context3.abrupt("return");
            case 10:
              if (!(isEU && !euTosPriv)) {
                _context3.next = 13;
                break;
              }
              setAuthenticated(false, {
                errorName: "AGREE_TOS"
              });
              return _context3.abrupt("return");
            case 13:
              setLoading(true);
              _context3.prev = 14;
              config = window.mlbOkta.getAuthConfig();
              registerUrl = "".concat(config.profile, "/users?activate=true");
              _email = registrationValues.email, _years = registrationValues.years, _months = registrationValues.months, _days = registrationValues.days;
              postData = {
                profile: {
                  email: _email,
                  birthYear: _years && parseInt(_years, 10),
                  birthMonth: _months && parseInt(_months, 10),
                  birthDay: _days && parseInt(_days, 10),
                  commercialEmailsOptin: optInChecked
                },
                credentials: {
                  password: {
                    value: registrationValues.password
                  }
                }
              };
              _context3.next = 21;
              return axios.post(registerUrl, postData);
            case 21:
              registerResponse = _context3.sent;
              if (!registerResponse.data.errorCode) {
                _context3.next = 27;
                break;
              }
              registerError = new Error(registerResponse.data.errorCode);
              registerError.message = registerResponse.data.errorSummary;
              setLoading(false);
              return _context3.abrupt("return", onError(registerError));
            case 27:
              _context3.next = 29;
              return login(registrationValues.email, registrationValues.password);
            case 29:
              logins = _context3.sent;
              _context3.next = 32;
              return authorizeToken(oktaClient, logins.mlbOktaLogin);
            case 32:
              tokenAuthorized = _context3.sent;
              if (tokenAuthorized) {
                window.mlbOkta.setOktaIdCookie();
                // set a normal 1 minute cookie
                window.mlbOkta.setAccessTokeninCookie();
                setLoading(false);
                setAuthenticated(true, null);
                _window$mlbOkta$decod = window.mlbOkta.decodeIdToken(), sub = _window$mlbOkta$decod.sub;
                if (window.trackAsync) {
                  window.trackAsync(_objectSpread(_objectSpread({}, registerSuccessProps), {}, {
                    prop22: sub
                  }));
                }
                onSuccess();
              }
              _context3.next = 43;
              break;
            case 36:
              _context3.prev = 36;
              _context3.t0 = _context3["catch"](14);
              setLoading(false);
              setAuthenticated(false, _context3.t0);
              if (window.trackAsync) {
                window.trackAsync(registerFailureProps);
              }
              dispatchRegisterState({
                type: RegisterStateActionTypes.REGISTRATION_ERRORS,
                payload: {
                  emailValid: null,
                  passwordValid: null,
                  confirmPasswordValid: null,
                  monthsValid: null,
                  daysValid: null,
                  yearsValid: null
                }
              });
              onError(_context3.t0);
            case 43:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[14, 36]]);
    }));
    return function handleSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleFieldChange = function handleFieldChange(fieldType, inputValue) {
    dispatchRegisterState({
      type: RegisterStateActionTypes.HANDLE_FIELD_CHANGE,
      payload: {
        inputValue: inputValue,
        fieldType: fieldType,
        emailValid: null,
        passwordValid: null,
        confirmPasswordValid: null,
        monthsValid: null,
        daysValid: null,
        yearsValid: null
      }
    });
    clearError();
  };
  var handleFocus = function handleFocus(fieldType) {
    if (fieldType === "password") {
      dispatchRegisterState({
        type: RegisterStateActionTypes.HANDLE_FOCUS,
        payload: {
          inputPrompt: true
        }
      });
      return;
    }
    dispatchRegisterState({
      type: RegisterStateActionTypes.HANDLE_FOCUS,
      payload: {
        inputPrompt: false
      }
    });
  };
  var backButtonClicked = function backButtonClicked() {
    onClickLoginLink();
    setAccountType(AccountTypes.LOGIN);
  };
  if (registerState.authenticated) {
    return /*#__PURE__*/React.createElement(RegisterSection, _extends({
      className: "".concat(classPrefix, "__section"),
      style: {
        backgroundColor: backgroundColor,
        width: containerWidth
      },
      success: true
    }, containerProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 502,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(RegisterContainer, {
      className: "".concat(classPrefix, "__container"),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 508,
        columnNumber: 9
      }
    }, successHeader && /*#__PURE__*/React.createElement(RegisterHeader, {
      className: "".concat(classPrefix, "__header"),
      dangerouslySetInnerHTML: {
        __html: successHeader
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 510,
        columnNumber: 13
      }
    }), successSubHeader && /*#__PURE__*/React.createElement(RegisterSubHeader, {
      className: "".concat(classPrefix, "__subheader"),
      dangerouslySetInnerHTML: {
        __html: successSubHeader
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 516,
        columnNumber: 13
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(RegisterSection, _extends({
      className: "".concat(classPrefix, "__section"),
      style: {
        backgroundColor: backgroundColor,
        width: containerWidth
      }
    }, containerProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 526,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(RegisterContainer, {
      className: "".concat(classPrefix, "__container"),
      isEU: isEU,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 531,
        columnNumber: 9
      }
    }, loading && /*#__PURE__*/React.createElement(Spinner, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 532,
        columnNumber: 23
      }
    }), header && /*#__PURE__*/React.createElement(RegisterHeader, {
      className: "".concat(classPrefix, "__header"),
      dangerouslySetInnerHTML: {
        __html: header
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 534,
        columnNumber: 13
      }
    }), subHeader && /*#__PURE__*/React.createElement(RegisterSubHeader, {
      className: "".concat(classPrefix, "__subheader"),
      dangerouslySetInnerHTML: {
        __html: subHeader
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 540,
        columnNumber: 13
      }
    }), !loading && /*#__PURE__*/React.createElement(RegistrationForm, {
      handleSubmit: handleSubmit,
      handleFieldChange: handleFieldChange,
      handleFocus: handleFocus,
      backButtonClicked: backButtonClicked,
      isEU: isEU,
      email: email,
      stacked: stacked,
      emailDisabled: emailDisabled,
      birthdayDisabled: birthdayDisabled,
      showOptinCheckbox: showOptinCheckbox,
      showPolicy: showPolicy,
      registerState: registerState,
      copyConfig: combinedCopyConfig,
      popoverPosition: popoverPosition,
      popoverOffset: popoverOffset,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 546,
        columnNumber: 13
      }
    })));
  }
};
Register.propTypes = {
  backgroundColor: PropTypes.string,
  birthday: PropTypes.shape({
    day: PropTypes.number,
    month: PropTypes.number,
    year: PropTypes.number
  }),
  birthdayDisabled: PropTypes.bool,
  containerProps: PropTypes.object,
  containerWidth: PropTypes.string,
  classPrefix: PropTypes.string,
  email: PropTypes.string,
  emailDisabled: PropTypes.bool,
  isEU: PropTypes.bool,
  locale: PropTypes.string,
  popoverOffset: PropTypes.arrayOf(PropTypes.number),
  popoverPosition: PropTypes.oneOf(["left", "left-start", "left-end", "right", "right-start", "right-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end"]),
  setAccountType: PropTypes.func,
  showOptinCheckbox: PropTypes.bool,
  showPolicy: PropTypes.bool,
  stacked: PropTypes.bool,
  copyConfig: PropTypes.shape({
    widgetHeader: PropTypes.string,
    header: PropTypes.string,
    subHeader: PropTypes.string,
    emailPlaceholder: PropTypes.string,
    passwordPlaceholder: PropTypes.string,
    confirmPasswordPlaceholder: PropTypes.string,
    birthdayLabel: PropTypes.string,
    monthPlaceholder: PropTypes.string,
    dayPlaceholder: PropTypes.string,
    yearPlaceholder: PropTypes.string,
    optInLabel: PropTypes.string,
    policyLabel: PropTypes.string,
    submitButton: PropTypes.string,
    successHeader: PropTypes.string,
    successSubHeader: PropTypes.string,
    loginLabel: PropTypes.string,
    loginLink: PropTypes.string
  }),
  tracking: PropTypes.shape({
    registerSuccessProps: PropTypes.object,
    registerFailureProps: PropTypes.object,
    registerSubmitProps: PropTypes.object
  }),
  onSuccess: PropTypes.func,
  onError: PropTypes.func
};
export default Register;